import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Radio } from 'lucide-react';
import api from '@/lib/api';
import NowSellingCard from '@/components/NowSellingCard';
import BroadcastLiveGrid from '@/components/BroadcastLiveGrid';

// Consumer-facing live page. Heavy lifting is delegated to shared components:
//   - <NowSellingCard variant="hero"/>       polls active_product every 4s
//   - <BroadcastLiveGrid />                  numbered slots + slot search
// Both share the standard <OptionSheet/> so cart + order plumbing is reused.

const LiveBroadcastView = () => {
  const { broadcastId } = useParams();
  const navigate = useNavigate();
  const [meta, setMeta] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/public/broadcasts/${broadcastId}/active-product`);
        setMeta(res.data);
      } catch (e) { setNotFound(true); }
    })();
  }, [broadcastId]);

  if (notFound) {
    return <div className="max-w-2xl mx-auto p-10 text-center" data-testid="live-view-error">
      <p className="text-xl font-black mb-3">방송을 찾을 수 없습니다</p>
      <Link to="/schedule" className="text-sm text-[#FF3B30] font-bold hover:underline">전체 편성표로 이동</Link>
    </div>;
  }
  if (!meta) return <div className="max-w-2xl mx-auto p-10 text-sm text-gray-400 text-center">불러오는 중…</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 space-y-6" data-testid="live-view-page">
      <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-black dark:hover:text-white" data-testid="live-view-back">
        <ArrowLeft size={14} /> 뒤로
      </button>

      <div className="rounded-3xl bg-gradient-to-br from-[#FF3B30] to-[#D32F2F] text-white p-6 shadow-lg" data-testid="live-view-hero">
        <p className="text-xs font-black inline-flex items-center gap-1 mb-2">
          <span className="inline-block w-2 h-2 rounded-full bg-white animate-pulse" /> LIVE
        </p>
        <h1 className="text-2xl font-black leading-tight" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="live-view-title">{meta.title || '라이브 방송'}</h1>
        {meta.seller_id && (
          <Link to={`/seller/${meta.seller_id}`} className="mt-2 inline-block text-xs font-bold underline opacity-90" data-testid="live-view-seller-link">셀러 프로필 보기</Link>
        )}
      </div>

      {/* 지금 소개중 (hero) */}
      <NowSellingCard broadcastId={broadcastId} variant="hero" />

      {/* 오늘 방송 상품 (numbered slots + slot search) */}
      <BroadcastLiveGrid broadcastId={broadcastId} />

      <p className="text-[11px] text-gray-400 text-center inline-flex items-center gap-1 justify-center w-full">
        <Radio size={10} /> 자동 새로고침 (4초마다)
      </p>
    </div>
  );
};

export default LiveBroadcastView;
